<template>
  <div class="rd-screen">
    <report-tools :copy="rows.length > 0" @copy="copyTable"></report-tools>

    <report-state v-if="loading" kind="loading"></report-state>
    <report-state
      v-else-if="!rows.length"
      icon="mdi-domain"
      :title="emptyTitle"
      :text="emptyText"
    ></report-state>
    <company-desktop-taken-table
      v-else
      :sections="sections"
      :shifts="visibleShifts"
      :name-label="$t('firm')"
      :show-taken="canCheckReport"
    ></company-desktop-taken-table>
  </div>
</template>

<script>
import CompanyReportTabTakenCompany from "@/components/company/reports/companyTabs/CompanyReportTabTakenCompany.vue";
import hasBarShifts from "@/components/report/shared/hasBarShifts";
import hasShiftSubtitle from "@/components/report/shared/hasShiftSubtitle";
import { copyText, rowsToTsv } from "@/components/report/desktop/copyTable";
import ReportState from "@/components/report/desktop/ReportState.vue";
import ReportTools from "@/components/report/desktop/ReportTools.vue";
import { hasPeriodRefetch } from "../../hasPeriodRefetch";
import { takenKpis, toTakenRow, toTakenSection, visibleTakenShifts } from "../../takenRows";
import CompanyDesktopTakenTable from "../CompanyDesktopTakenTable.vue";

/**
 * Preuzeto po firmama na računaru: red po firmi sa preuzeto / poručeno po smenama. Smene, firme, period i
 * pretragu čita iz zajedničke trake. Nasleđuje učitavanje, štampu i Excel iz starog taba. Mesečni izveštaj firme
 * (dugme u starom tabu) se ovde ne nudi: stari dijalog traži restoran iz store-a, kojeg nalog firme nema.
 */
export default {
  name: "CompanyDesktopTakenCompany",
  extends: CompanyReportTabTakenCompany,
  mixins: [hasBarShifts, hasShiftSubtitle, hasPeriodRefetch("fetchMeals")],
  components: { ReportState, ReportTools, CompanyDesktopTakenTable },
  computed: {
    rows() {
      const found = this.search
        ? this.customSearch(this.filteredCompanies, [{ value: "name" }], this.search)
        : this.filteredCompanies;
      return found
        .filter((company) => company.total > 0)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((company, index) => toTakenRow(company, `${company.name}-${index}`, this.toLatin(company.name)));
    },
    sections() {
      return this.rows.length ? [toTakenSection("all", "", this.rows)] : [];
    },
    visibleShifts() {
      return visibleTakenShifts(this.selectedShifts, this.sections);
    },
    emptyTitle() {
      return this.search
        ? this.$t("report_mobile.no_results_for", { search: this.search })
        : this.$t("no_taken_company_meals_data");
    },
    emptyText() {
      return this.search ? "" : this.$t("select_date_and_filters");
    },
    kpis() {
      return takenKpis((key) => this.$t(key), {
        sections: this.sections,
        showTaken: this.canCheckReport,
        countLabel: this.$t("companies"),
        count: this.rows.length,
      });
    },
  },
  watch: {
    kpis: {
      handler(kpis) {
        this.$emit("kpis", this.rows.length ? kpis : []);
      },
      immediate: true,
    },
    loading: {
      handler(loading) {
        this.$emit("loading", loading);
      },
      immediate: true,
    },
  },
  methods: {
    async copyTable() {
      const headers = [this.$t("firm"), ...this.visibleShifts.map((shift) => this.$t(shift.label)), this.$t("total")];
      const value = (ordered, taken) => (this.canCheckReport ? `${taken}/${ordered}` : String(ordered));
      const rows = this.rows.map((row) => [
        row.name,
        ...this.visibleShifts.map((shift) => {
          const cell = row.cells[shift.id];
          return cell.ordered ? value(cell.ordered, cell.taken) : "";
        }),
        value(row.ordered, row.taken),
      ]);
      const copied = await copyText(rowsToTsv(headers, rows));
      this.$emit("toast", this.$t(copied ? "report_desktop.copied" : "report_desktop.copy_failed"));
    },
  },
};
</script>
